export default __webpack_public_path__ + "static/media/bg-half.0cc5a583.png";